import { render, staticRenderFns } from "./ModalGuardarJurado.vue?vue&type=template&id=bd527744&scoped=true"
import script from "./ModalGuardarJurado.vue?vue&type=script&lang=js"
export * from "./ModalGuardarJurado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd527744",
  null
  
)

export default component.exports